import {
	IconButton,
	MimaButton,
	MimaText,
	Modal,
	MimaInput,
	MimaDropdown,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { Field, FieldArray, Formik } from 'formik';
import React from 'react';

const FieldInput = ({ field, ...props }) => {
	return <MimaInput {...field} {...props} />;
};

const FieldSelect = ({ field, ...props }) => {
	return <MimaDropdown {...field} {...props} />;
};

const BulkAddFunds = ({
	closeModal,
	totalExtra,
	idsCount,
	onSubmit,
	validationSchema,
	addFundList,
	loading,
}) => {
	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			<MimaText
				variant="subtitle"
				width={38}
				mb={3}
				align="center"
				color="var(--color-primary)">
				{`Add Funds to ${idsCount} Employee(s)`}
			</MimaText>
			<>
				<Formik
					initialValues={{
						payAdditions: [
							{
								type: '',
								amount: 0,
							},
						],
					}}
					validationSchema={validationSchema}
					onSubmit={onSubmit}>
					{({
						handleChange,
						handleBlur,
						handleSubmit,
						setFieldValue,
						values,
						errors,
						touched,
					}) => (
						<div>
							{values.payAdditions.length ? (
								<MimaText
									mb={2}
									align="center"
									color="var(--color-primary)"
									variant="bodyBold">
									Add Funds
								</MimaText>
							) : (
								''
							)}
							<FieldArray name="payAdditions">
								{({ push, remove }) => (
									<React.Fragment>
										{values.payAdditions?.length
											? values?.payAdditions.map((item, i) => (
													<div key={i}>
														<Field
															as="select"
															component={FieldSelect}
															name={`payAdditions.${i}.type`}
															value={values.payAdditions[i].type}
															onChange={e => {
																setFieldValue(
																	`payAdditions.${i}.type`,
																	e.value
																);
															}}
															placeholder={
																values.payAdditions[i].type ||
																'Select Addition type'
															}
															data={addFundList.map(item => ({
																key: item,
																value: item,
															}))}
															labelTitle="Addition Type"
														/>
														{/* <MenuItem value=""></MenuItem>
																	{addFundList.map((fund, key) => (
																		<MenuItem key={key} value={fund}>
																			{fund}
																		</MenuItem>
																	))} */}

														<Field
															name={`payAdditions.${i}.amount`}
															type="number"
															component={FieldInput}
															labelTitle="Addition Amount"
															min="0"
														/>

														{i >= 0 ? (
															<IconButton
																variant="remove"
																onClick={() => remove(i)}
															/>
														) : (
															''
														)}
														<div className={styles.employee__list_line}> </div>
													</div>
												))
											: ''}
										<MimaButton
											title={`Add ${
												values.payAdditions.length > 0 ? 'Another' : ''
											} Fund`}
											type="button"
											onClick={() =>
												push({
													amount: 0,
													type: '',
												})
											}
											variant="filter"
											mt={2}
										/>
										<MimaText
											mt={3}
											align="center"
											color="var(--color-error)"
											width={38}>
											{`${totalExtra(
												values.payAdditions
											)} would be added to the selected employees
													`}
										</MimaText>
									</React.Fragment>
								)}
							</FieldArray>
							<MimaButton
								disabled={loading}
								loading={loading}
								title="Save"
								type="submit"
								onClick={handleSubmit}
								mt={5}
							/>
						</div>
					)}
				</Formik>
			</>
		</Modal>
	);
};

export default BulkAddFunds;
